const doorSideTypes = ['outside', 'inside'];

export default doorSideTypes;
